import { useMemo } from "react";
import { useParams } from "react-router-dom";
import Post from "./Post";
import PublicProfile from "./PublicProfile";

/**
 * Route helper for `/post/:slug`
 * - If slug is a Mongo ObjectId → render Post view
 * - Otherwise → render PublicProfile "post/card view"
 *
 * This avoids route conflicts between `/post/:username` and `/post/:postId`.
 */
const PostOrProfile = () => {
  const { slug } = useParams();

  const isValidObjectId = useMemo(() => /^[0-9a-fA-F]{24}$/.test(slug || ""), [slug]);

  return isValidObjectId ? <Post /> : <PublicProfile />;
};

export default PostOrProfile;

